import { connect } from 'react-redux';

import PageHeader from 'components/ReportsHistory/PageHeader';
import { getPatientName } from 'store/selectors/patientsData';

const mapStateToProps = (state, { patientId }) => ({
  patientName: getPatientName(patientId)(state),
});

export default connect(mapStateToProps)(PageHeader);
